import "./wizardPassport.scss";

// @vendor
import React, { Component, Fragment } from "react";
const { withRouter } = require('react-router-dom');
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ClassNames from "classnames";

// @common-components
const Wizard = require("components/commons/wizard/wizard");
const WizardStep = require("components/commons/wizardStep/wizardStep");
const WizardError = require("components/commons/wizardError/wizardError");
const WizardSuccess = require("components/commons/wizardSuccess/wizardSuccess");
const { OKSharedSocial } = require("commonsComponents/OKSharedSocial");
import { OKSummaryHireCardPassport } from "components/OKWizard/OKWizardSummaryPassport/OKWizardSummaryPassport";
const {
    CommercialAds
} = require("components/commons/commercialAds/commercialAds");

// @steps
import { ModifyCharityCardDataPassport } from "./steps/stepOne/modifyCharityCardDataPassport";
import { LimitCharityCardDataPassport } from "./steps/stepTwo/limitCharityCardDataPassport";
import { ConfirmCharityCardDataPassport } from "./steps/stepThree/confirmCharityCardDataPassport";

// @actions
import {
    confirmSolidarityCardTest,
    confirmSolidarityCardNotFound,
    validateStep,
    setVisibleStep,
    setWillCancel,
    setMinAmountLimit,
    setMaxAmountLimit
} from "actions/okWizardSolidarity";

// @constants
const { getSocialShareSolidarity } = require("constants/socialShare");
const { DATE_PICKER_CUSTOM_LOCALE } = require('constants/commonsComponents');

// @ core
const moment = require("moment");

// @utils
const PersonalDataHelper = require('utilities/personalDataHelper');
import { i18n } from "core/i18n";
const { formatText, FormattedText } = i18n;
const DateHelper = require('utilities/dateHelper');

class WizardPassport extends Component {

    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
    }

    onCancel = () => {
        this.props.history.push("/myprofile/cards/");
    };

    onFinish = () => {
        const {
            immCardById,
            cardId,
            confirmSolidarityCardTest,
            confirmSolidarityCardNotFound,
            newNGOCard
        } = this.props;

        const contractNumber = immCardById
            .get(cardId)
            .getIn(["contract", "number"]);

        const panNumber = immCardById
            .get(cardId)
            .get("number")
            .replace(/\s/g, "");

        if (!newNGOCard) {
            confirmSolidarityCardTest(contractNumber);
        } else {
            confirmSolidarityCardNotFound(contractNumber, panNumber);
        }
    };

    buildSuccessMessage = () => {
        const { immCardById, cardId, minAmount, maxAmount, ngos, immProfile } = this.props;
        const mainButton = {
            label: (
                <FormattedText value="confirmationSolidarityCard-mainButton" />
            ),
            url: "/myprofile/cards",
            action: () => {}
        };
        const immCard = immCardById.get(cardId);
        const locale = formatText(DATE_PICKER_CUSTOM_LOCALE);

        const date = DateHelper.getLocalsDate(moment()
            .locale(locale)
            .startOf("month")
            .add(1, "month")
            .format("LL"),locale);
        const NGOList = ngos
            ? ngos.map((ngo, index) => {
                  return <li key={index}>{ngo.name}</li>;
              })
            : null;
        const month = formatText("common-month").toLowerCase();
        const limitlessAmount = formatText("confirmationSolidarityCard-limitlessAmount");
        const textMaxAmount =
            maxAmount === 99999999 ? limitlessAmount : `${maxAmount} €/${month}`;
        const email = PersonalDataHelper.getEmail(immProfile);

        return (
            <div className="col-xs-12">
                <div className="wizard-passport__success-wizard-container">
                    <WizardSuccess
                        successMessage={
                            <FormattedText
                                value="confirmationSolidarityCard-solidarityConfirmationTitle"
                                className="wizard-passport__title"
                            />
                        }
                        successMessageChildren={
                            <FormattedText
                                injectedStrings={[date]}
                                value="confirmationSolidarityCard-solidarityConfirmationSubtitle"
                                className="wizard-passport__subtitle"
                            />
                        }
                        mainButton={mainButton}
                    >
                        <div className="wizard-passport__container">
                            <div className="row">
                                <div className="col-xs-4">
                                    <div className="wizard-passport__image-container">
                                        <CommercialAds
                                            path="cards"
                                            type="cards"
                                            immCard={immCard}
                                            size="medium"
                                        />
                                    </div>
                                </div>
                                <div className="col-xs-4">
                                    <FormattedText value="confirmationSolidarityCard-selectedNGOsConfirmation" />
                                    <ul className="ok-summary-hire-card-passport__info-container-list">
                                        {NGOList}
                                    </ul>
                                </div>
                                <div className="col-xs-4">
                                    <FormattedText value="common-minimumLimit" />
                                    <div className="passport-hire-confirmation__summary-data">
                                        {`${minAmount} €/`}
                                        <FormattedText
                                            value="common-month"
                                            format="lowercase"
                                        />
                                    </div>
                                    <FormattedText
                                        value="common-maximumLimit"
                                        className="passport-hire-confirmation__summary-title"
                                    />
                                    <div className="passport-hire-confirmation__summary-data">
                                        {`${textMaxAmount}`}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <FormattedText value="confirmationSolidarityCard-documentsConfirmation"
                                injectedStrings={[email]}
                            />
                        </div>
                        <div className="wizard-passport__shared-social">
                            <OKSharedSocial {...getSocialShareSolidarity()} />
                        </div>
                    </WizardSuccess>
                </div>
            </div>
        );
    };

    buildErrorMessage = () => {
        const mainButton = {
            label: (
                <FormattedText value="confirmationSolidarityCard-mainButton" />
            ),
            url: "/myprofile/cards",
            action: () => {}
        };

        return (
            <div className="col-xs-12">
                <WizardError
                    errorMessage={
                        <FormattedText value="confirmationSolidarityCard-genericError" />
                    }
                    mainButton={mainButton}
                >
                    <FormattedText value="confirmationSolidarityCard-genericErrorText" />
                </WizardError>
            </div>
        );
    };

    buildWizardContentPassport = () => {
        const {
            propsWizard,
            ngos,
            currentStep,
            validateStep,
            setVisibleStep,
            setWillCancel,
            minAmount,
            maxAmount,
            setMinAmountLimit,
            setMaxAmountLimit,
            immSteps,
            immCardById,
            cardId,
            isFetching,
            successOperation,
            errorOperation,
            newNGOCard
        } = this.props;

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.onFinish,
            cancel: this.onCancel
        };

        const nextButtonDisabled = !ngos || ngos.length === 0;

        const immCard = immCardById.get(cardId);
        const cardType = immCard.getIn(["alias", "current"]);

        if (successOperation) {
            return this.buildSuccessMessage();
        } else if (errorOperation || (__CONTACT_CENTER__ && errorOperation)) {
            return this.buildErrorMessage();
        } else {
            return (
                <Wizard
                    actions={actions}
                    immSteps={immSteps}
                    showPreLeaveModal={true}
                    stepsAmount={immSteps.size}
                    visibleStep={currentStep}
                    wizardClass="wizard-passport__wizard"
                >
                    <WizardStep
                        position="first"
                        cancelButton={true}
                        nextButton={true}
                        nextButtonDisabled={nextButtonDisabled}
                    >
                        <ModifyCharityCardDataPassport
                            {...propsWizard}
                            ngos={ngos}
                            newNGOCard={newNGOCard}
                        />
                    </WizardStep>
                    <WizardStep
                        position="middle"
                        cancelButton={true}
                        nextButton={true}
                        previousButton={true}
                    >
                        <LimitCharityCardDataPassport
                            {...propsWizard}
                            minAmount={minAmount}
                            maxAmount={maxAmount}
                            setMinAmountLimit={setMinAmountLimit}
                            setMaxAmountLimit={setMaxAmountLimit}
                        />
                    </WizardStep>
                    <WizardStep
                        addLoadingBehaviour={true}
                        cancelButton={true}
                        immFinalButton="hireSolidarityCard-confirmationButton"
                        isLoading={isFetching}
                        previousButton={true}
                        finishButton={true}
                        position="last"
                    >
                        <ConfirmCharityCardDataPassport
                            {...propsWizard}
                            ngos={ngos}
                            minAmount={minAmount}
                            maxAmount={maxAmount}
                            cardType={cardType}
                            immCard={immCard}
                        />
                    </WizardStep>
                </Wizard>
            );
        }
    };

    buildSummary = () => {
        const {
            ngos,
            minAmount,
            maxAmount,
            immCardById,
            cardId,
            immAccountsById,
            cardAccount,
            selectedImageId,
            imagesById,
            successOperation,
            errorOperation
        } = this.props;

        const immCard = immCardById.get(cardId);
        const cardType = immCard.getIn(["alias", "current"]);
        const selectedAccount = immAccountsById.get(cardAccount).get("alias");

        if (!successOperation && !errorOperation) {
            return (
                <div className="col-xs-12 col-md-4">
                    <div className="grid-view--content-position-negative">
                        <OKSummaryHireCardPassport
                            ngos={ngos}
                            minAmount={minAmount}
                            maxAmount={maxAmount}
                            cardType={cardType}
                            selectedAccount={selectedAccount}
                            selectedImageId={selectedImageId}
                            imagesById={imagesById}
                            immCard={immCard}
                        />
                    </div>
                </div>
            );
        } else {
            return null;
        }
    };

    render() {
        const { successOperation, errorOperation } = this.props;

        const gridClass = ClassNames("grid-view__body col-xs-12 ", {
            "col-md-12": successOperation || errorOperation,
            "col-md-8": !successOperation && !errorOperation
        });
        return (
            <Fragment>
                <div className={gridClass}>
                    <div className="grid-view--content-position-negative">
                        {this.buildWizardContentPassport()}
                    </div>
                </div>
                {this.buildSummary()}
            </Fragment>
        );
    }
}

WizardPassport.propTypes = {
    cardId: PropTypes.string,
    history: PropTypes.object.isRequired,
    immCardById: PropTypes.object,
    confirmSolidarityCardTest: PropTypes.func,
    confirmSolidarityCardNotFound: PropTypes.func,
    propsWizard: PropTypes.object,
    charityFoundationsError: PropTypes.bool,
    submitResults: PropTypes.func,
    isFetching: PropTypes.bool,
    isError: PropTypes.bool,
    ngos: PropTypes.object,
    newNGOCard: PropTypes.bool,
    minAmount: PropTypes.number,
    maxAmount: PropTypes.number,
    cardAccount: PropTypes.string,
    immAccountsById: PropTypes.object,
    selectedImageId: PropTypes.string,
    imagesById: PropTypes.object,
    currentStep: PropTypes.number,
    validateStep: PropTypes.func,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    setMinAmountLimit: PropTypes.func,
    setMaxAmountLimit: PropTypes.func,
    immSteps: PropTypes.object,
    successOperation: PropTypes.bool,
    errorOperation: PropTypes.bool,
    immProfile: PropTypes.object.isRequired
};

module.exports.WizardPassport = connect(
    state => ({
        isFetching: state.okWizardSolidarity.get("isFetching"),
        successOperation: state.okWizardSolidarity.get("successOperation"),
        errorOperation: state.okWizardSolidarity.get("errorOperation"),
        isError: state.okWizardSolidarity.get("isError"),
        center: state.okWizardSolidarity.get("centro"),
        contract: state.okWizardSolidarity.get("contrato"),
        entity: state.okWizardSolidarity.get("entidad"),
        maxAmount: state.okWizardSolidarity.get("maxAmount"),
        minAmount: state.okWizardSolidarity.get("minAmount"),
        ngos: state.okWizardSolidarity.get("ngos"),
        newNGOCard: state.okWizardSolidarity.get("newNGOCard"),
        pan: state.okWizardSolidarity.get("pan"),
        product: state.okWizardSolidarity.get("producto"),
        immAccountsById: state.accounts.get("byId"),
        selectedImageId: state.hireCardImageSelector.get("selectedImageId"),
        immHireCardNameSelector: state.hireCardNameSelector,
        imagesById: state.hireCardImageSelector.get("imagesById"),
        currentStep: state.okWizardSolidarity.get("currentStep"),
        immSteps: state.okWizardSolidarity.get("steps"),
        immProfile: state.profile
    }),
    {
        confirmSolidarityCardTest,
        confirmSolidarityCardNotFound,
        validateStep,
        setVisibleStep,
        setWillCancel,
        setMinAmountLimit,
        setMaxAmountLimit,
    }
)(withRouter(WizardPassport));
